import React from 'react'
import { Flex, Table, Text } from '@workwhile/ui'
import { ColumnDef } from '@tanstack/react-table'
import { AccordionCard } from 'components/AccordionCard'
import { useJurisdictionDetailContextValue } from '../context/JurisdictionDetailProvider'
import { useJurisdictionQuery } from 'queries/wage/useJurisdictionQuery'

type ActiveRule = NonNullable<
  ReturnType<typeof useJurisdictionQuery>['data']
>['rules'][number]

const columns: ColumnDef<ActiveRule>[] = [
  {
    header: 'Rule ID',
    accessorKey: 'id',
    size: 90,
  },
  {
    header: 'Effective Start',
    accessorKey: 'effectiveStart',
    size: 140,
  },
  {
    header: 'Effective End',
    accessorKey: 'effectiveEnd',
    size: 140,
    cell: ({ row }) =>
      row.original.effectiveEnd ?? <Text color="lightText">Open-ended</Text>,
  },
  {
    header: 'Coverage Scope',
    accessorKey: 'coverageScope',
    size: 180,
    cell: ({ row }) =>
      row.original.coverageScope === 'full' ? 'Full' : 'Unincorporated only',
  },
]

export const ActiveRulesTable = () => {
  const {
    state: { rules },
  } = useJurisdictionDetailContextValue()

  const activeRules = rules ?? []

  return (
    <AccordionCard
      title={
        <Text fontSize={2} color="lightText">
          Active Rules
        </Text>
      }
    >
      {activeRules.length === 0 ? (
        <Flex justifyContent="center" p={3}>
          <Text color="lightText">No active rules for this jurisdiction.</Text>
        </Flex>
      ) : (
        <Table
          columns={columns}
          data={activeRules}
          textVerticalAlign="middle"
        />
      )}
    </AccordionCard>
  )
}
